import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  chatHistories: undefined,
};

const dataWorkbenchChatSlice = createSlice({
  name: 'dataWorkbenchChat',
  initialState,
  reducers: {
    setChatHistories(state, action) {
      state.chatHistories = action.payload;
    },
  },
});

export const { setChatHistories } = dataWorkbenchChatSlice.actions;
export default dataWorkbenchChatSlice.reducer; 